export default __webpack_public_path__ + "static/media/YAS0270.34I-27743_-17216_0.ab29ff44.jpg";